var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashBoardTearSheetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34444 0H14.6567C18.0889 0 20 1.78 20 4.83V15.16C20 18.26 18.0889 20 14.6567 20H5.34444C1.96667 20 0 18.26 0 15.16V4.83C0 1.78 1.96667 0 5.34444 0ZM9 5.6H6C5.77909 5.6 5.6 5.77909 5.6 6V14C5.6 14.2209 5.77909 14.4 6 14.4H9C9.01337 14.4 9.02658 14.3993 9.03962 14.3981C9.01364 14.2694 9 14.1363 9 14V6C9 5.8637 9.01364 5.73058 9.03962 5.60194C9.02658 5.60066 9.01337 5.6 9 5.6ZM9 16C9.36429 16 9.70583 15.9026 10 15.7324C10.2942 15.9026 10.6357 16 11 16H14C15.1046 16 16 15.1046 16 14V6C16 4.89543 15.1046 4 14 4H11C10.6357 4 10.2942 4.09739 10 4.26757C9.70583 4.09739 9.36429 4 9 4H6C4.89543 4 4 4.89543 4 6V14C4 15.1046 4.89543 16 6 16H9ZM11 14.4C10.9866 14.4 10.9734 14.3993 10.9604 14.3981C10.9864 14.2694 11 14.1363 11 14V6C11 5.8637 10.9864 5.73058 10.9604 5.60194C10.9734 5.60066 10.9866 5.6 11 5.6H14C14.2209 5.6 14.4 5.77909 14.4 6V14C14.4 14.2209 14.2209 14.4 14 14.4H11Z",
    fill: "#0680E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardTearSheetIcon);
export default __webpack_public_path__ + "static/media/DashBoardTearSheetIcon.4cd5dcf2b4841f16ae2449b670994cea.svg";
export { ForwardRef as ReactComponent };